export function getEnvironmentValue<T extends Object>(env:any, key:string, e?:T):string{
    if(!env[key]) throw(new Error(`Missing env key ${key}`));
    const value:string = env[key]!;
    if(e && Object.values(e).includes(value) === false) throw(new Error(`env key ${key} must be one of ${Object.values(e)}, got ${value}`))
    return value;
}
